import { Job } from './actions';

export interface JobsState {
  pending: boolean;
  jobs: Job[] | null;
  error?: string;
}

export const defaultJobsState: JobsState = {
  pending: false,
  jobs: null,
  error: null,
};

export interface JobState {
  pending: boolean;
  job: Job | null;
  error?: string;
}

export const defaultJobState: JobState = {
  pending: false,
  job: null,
  error: null,
};

export interface JobLogsState {
  pending: boolean;
  id: Job['id'] | null;
  logs: string | null;
  error?: string;
}

export const defaultJobLogsState: JobLogsState = {
  pending: false,
  id: null,
  logs: null,
  error: null,
};
